import { cn } from '@/shared/lib/cn';

export interface ProgressBarProps {
  /** Wartosc biezaca. */
  value: number;
  /** Wartosc maksymalna. */
  max: number;
  /** Etykieta nad paskiem (np. „Postęp turnieju”). */
  label?: string;
  /** Tekst po prawej stronie etykiety (np. „18 / 31 meczów”). */
  caption?: string;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Liniowy wskaznik postepu — jak „Postęp turnieju 18 / 31 meczów”
 * w naglowku centrum turnieju.
 */
export function ProgressBar({
  value,
  max,
  label,
  caption,
  size = 'md',
  className,
}: ProgressBarProps) {
  const safeMax = max > 0 ? max : 1;
  const percent = Math.min(100, Math.max(0, (value / safeMax) * 100));

  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5', className)}>
      {(label ?? caption) && (
        <div className="flex items-baseline justify-between gap-3">
          {label && <span className="text-fg-muted text-xs font-medium">{label}</span>}
          {caption && <span className="text-fg text-sm font-semibold">{caption}</span>}
        </div>
      )}

      <div
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-label={label}
        className={cn(
          'bg-surface-sunken border-border w-full overflow-hidden rounded-full border',
          size === 'sm' ? 'h-1.5' : 'h-2',
        )}
      >
        <div
          className="bg-brand h-full rounded-full transition-[width] duration-500 ease-out"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
